import { InjectionToken  } from '@angular/core';
import { CpControlSuggestions } from '../../se-smart-text-editor/suggestion-datasource/suggestion';
import { SuggestionDataSource } from '../../se-smart-text-editor/suggestion-datasource/suggestion-data-source';

export const SUGGESTION_STREAM_TOKEN = new InjectionToken<SuggestionDataSource>('SUGGESTION_STREAM_TOKEN');
export const FILTER_STREAM_TOKEN = new InjectionToken<SuggestionDataSource>('FILTER_STREAM_TOKEN');
export const LIGHT_LAYOUT_TOKEN = new InjectionToken<boolean>('LIGHT_LAYOUT_TOKEN');
export const DEFAULT_TEXT_NAME_TOKEN = new InjectionToken<string>('DEFAULT_TEXT_NAME_TOKEN');
export const TEXTS_GROUP_TOKEN = new InjectionToken<Map<string, CpControlSuggestions>>('TEXTS_GROUP_TOKEN');

